import {
  _getRequestTokenResponse,
  _getRefreshTokenResponse,
  _getRefreshTokenAckResponse,
  // _getRegisterDeviceResponse,
} from "./Network/JHHLogin";
import {
  _getGUID,
  _initalizeClientPublicKey,
  _setDHRefreshLocalItems,
  deviceType,
  versionNumber,
  _getDeviceInfo,
  _getUserInfo,
  _getAccessToken,
  _getClientPublicKey,
  language,
} from "network-helper";
import { EStatus } from "./Enums/generic";

import * as _ from "lodash";
import { _setAccessTokenHeader } from "./HandleApi";

interface ISetRequestToken {
  dataObj?:{[key:string]: string };
  url?: string
} 

const _getRegisterDeviceFormData = async (userId: string, jioId: string) => {
  const gUID = _getGUID();
  const dataObj = {
    device_id: "",
    device_os: navigator.platform,
    device_user_id: userId,
    device_jio_id: jioId,
    unique_id: gUID,
    device_name: navigator.userAgent,
    device_model: navigator.appName,
    sync_id: gUID,
    lang_name: language,
    device_type: deviceType,
    version_number: versionNumber,
  };
  return dataObj;
};

const _getRefreshTokenDeviceInfo = async () => {
  try {
    let dataObj;
    const deviceInfo = _getDeviceInfo();
    const userInfo = _getUserInfo();
    if (deviceInfo !== null && userInfo !== null) {
      const deviceDetails = deviceInfo ? JSON.parse(deviceInfo) : "";
      const userDetails = userInfo ? JSON.parse(userInfo) : "";
      dataObj = {
        public_key: _initalizeClientPublicKey(),
        device_jio_id: deviceDetails.hhub_id,
        device_auth_key: userDetails.auth_key,
        device_id: deviceDetails.device.id,
        unique_id: deviceDetails.device.unique_id,
        sync_id: deviceDetails.device.sync_id,
        device_type: deviceDetails.device.device_type,
        version_number: deviceDetails.device.version_no,
      };
    } else {
      const gUID = _getGUID();
      dataObj = {
        public_key: _initalizeClientPublicKey(),
        device_jio_id: "",
        device_auth_key: "",
        device_id: "",
        unique_id: gUID,
        sync_id: gUID,
        device_type: deviceType,
        version_number: versionNumber,
      };
    }
    return dataObj;
  } catch (err) {
    throw err;
  }
};

export const _setRequestToken = async ({dataObj, url}:ISetRequestToken) => {
  try {
    const data={
      "public_key":_initalizeClientPublicKey(),
      "device_type":deviceType,
      "version_number":versionNumber,
      ...dataObj
    }
    
    const response = await _getRequestTokenResponse(data, url);
    if (response && response.token && response.public_key && response.ttl) {
      _setDHRefreshLocalItems(response);
    }
    return response;
  } catch (err) {
    throw err;
  }
};

const _getRefreshTokenAck = async () => {
  try {
    const clientPublicKey = _getClientPublicKey();
    const accessToken = _getAccessToken();
    if (clientPublicKey !== null && accessToken !== null) {
      const datObj = {
        public_key: clientPublicKey,
        device_type: deviceType,
        version_number: versionNumber,
      };
      const result = await _getRefreshTokenAckResponse(datObj);
      const status = _.get(result, "status");
      if (status === EStatus.SUCCESS) {
        return { status: "success" };
      }
    }
  } catch (err) {
    throw err;
  }
};

export const _getRefreshToken = async () => {
  try {
    const accessToken = _getAccessToken();
    const userInfo = JSON.parse(_getUserInfo());
    if (accessToken !== null && userInfo !== null) {
      const response = await _getRefreshTokenResponse(
        await _getRefreshTokenDeviceInfo()
      );
      if (response && response.token && response.public_key && response.ttl) {
        _setDHRefreshLocalItems(response);
        const result = await _getRefreshTokenAck();
        const status = _.get(result, "status", "");
        if (status === EStatus.SUCCESS) {
          return { status: "success" };
        }
      }
    }
    else {
      try{
        await _setAccessTokenHeader();
        return { status: "success" };
      } catch(err){
        throw err;
      }
    }
  } catch (err) {
    throw err;
  }
};

// export const _registerDevice = async (dataObj = {}) => {
//   try {
//     const accessToken = _getAccessToken();
//     const userInfo = _getUserInfo();
//     if (accessToken !== null && userInfo !== null) {
//       const userId = userInfo ? JSON.parse(userInfo).id : 0;
//       const jioId = userInfo ? JSON.parse(userInfo).jio_id : 0;
//       const result = await _getRegisterDeviceResponse(
//         {... await _getRegisterDeviceFormData(userId, jioId), ...dataObj}
//       );
//       if (result.status === EStatus.SUCCESS) {
//         return { status: result.status };
//       }
//     }
//   } catch (err) {
//     throw err;
//   }
// };
